import { render, staticRenderFns } from "./GuestFooter.vue?vue&type=template&id=5ae3cbf7"
import script from "./GuestFooter.vue?vue&type=script&lang=js"
export * from "./GuestFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports